export enum MapMode {
  MODE_DECLARED = "declared",
  MODE_PERCEIVED = "perceived",
  MODE_TRANSPARENCY = "transparency",
  MODE_APT = "apt",
}
